import { render, staticRenderFns } from "./detail-meeting-header.vue?vue&type=template&id=0cb1e320&"
import script from "./detail-meeting-header.vue?vue&type=script&lang=js&"
export * from "./detail-meeting-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb1e320')) {
      api.createRecord('0cb1e320', component.options)
    } else {
      api.reload('0cb1e320', component.options)
    }
    module.hot.accept("./detail-meeting-header.vue?vue&type=template&id=0cb1e320&", function () {
      api.rerender('0cb1e320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/detail-meeting-header/detail-meeting-header.vue"
export default component.exports